/**
 * Store-bound days-remaining range editor for the Reserved Item Expiration filter option.
 */
import { observer } from "mobx-react";
import RmaListFiltersStore from "../../../../rma-list-page/stores/rma-list-filters-store";
import RmaListFilterNumberRangeContent from "../../rma-list-filter-control/contents/number-range/rma-list-filter-number-range-content";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
}

const ReservedItemDaysRemainingContent: React.FC<IProps> = observer(
    ({ rmaListFiltersStore }) => {
        const daysStore = rmaListFiltersStore.reservedItemDaysRemainingStore;

        return (
            <RmaListFilterNumberRangeContent
                value={{ from: daysStore.from, to: daysStore.to }}
                onChange={({ from, to }) => {
                    daysStore.setFrom(from);
                    daysStore.setTo(to);
                }}
            />
        );
    },
);

export default ReservedItemDaysRemainingContent;
